/* ============================================================================
   assets/ll-welcome.js
   Behaviour for sections/welcome-about.liquid.

     Watchlist card   "Watching 3" from the storefront's one watchlist, kept
                      in step when the header or a hub changes it.
     Game card        "Jump back into Pokémon" when this device picked a game
                      in the TCG hub in the last 30 days.
     Hub links        #ll-tcg-hub (and the old #tcg) scroll smoothly to the hub.
     Story            folds on phones behind Read more; the text stays in the
                      page, so it is still indexed and findable in-page.
   Everything reads localStorage on this device only; nothing is sent.
============================================================================ */
(function () {
  if (window.__llWelcomeJS) return;
  window.__llWelcomeJS = true;

  var K_WATCH = 'll_watchlist';
  var K_LAST = 'll_tcg_last';

  function readJSON(key, fb) {
    try { var v = localStorage.getItem(key); return v ? JSON.parse(v) : fb; } catch (e) { return fb; }
  }
  function watchCount() {
    var l = readJSON(K_WATCH, []);
    if (Object.prototype.toString.call(l) === '[object Array]') return l.length;
    return 0;
  }

  function resolveHub(hash, allowFallback) {
    var id = String(hash || '').replace(/^#/, '');
    if (!id) return null;
    if (id.toLowerCase() === 'tcg') id = 'll-tcg-hub';
    var el = document.getElementById(id);
    if (el) return el;
    return allowFallback ? document.querySelector('[data-lltc-root]') : null;
  }
  function scrollToEl(el) {
    if (!el) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try { el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); } catch (e) { el.scrollIntoView(true); }
  }

  function boot(root) {
    if (!root || root.__llwaReady) return;
    root.__llwaReady = true;

    /* ---- watchlist badge ---- */
    var badge = root.querySelector('[data-watch-badge]');
    function paintWatch() {
      if (!badge) return;
      var n = watchCount();
      badge.hidden = n < 1;
      badge.textContent = 'Watching ' + n;
      var card = badge.closest('[data-tool]');
      var lab = card && card.querySelector('[data-tool-label]');
      if (lab) {
        if (!lab.__orig) lab.__orig = lab.textContent;
        lab.textContent = n > 0 ? 'See your ' + n + ' saved' : lab.__orig;
      }
    }
    paintWatch();
    document.addEventListener('ll:watchlist:change', paintWatch);
    window.addEventListener('storage', function (e) { if (!e.key || e.key === K_WATCH) paintWatch(); });

    /* ---- back into the last game ---- */
    var hubCard = root.querySelector('[data-tool="hub"]');
    function paintGame() {
      if (!hubCard) return;
      var last = readJSON(K_LAST, null);
      if (!last || !last.g || !last.ts || (Date.now() - last.ts) > 30 * 86400000) return;
      var tab = document.querySelector('[data-lltc-root] [data-tab][data-game="' + String(last.g).replace(/"/g, '') + '"]');
      var name = tab && tab.getAttribute('data-label');
      if (!name) return;
      var lab = hubCard.querySelector('[data-tool-label]');
      if (lab) lab.textContent = 'Jump back into ' + name;
    }
    paintGame();

    /* ---- hub anchors ---- */
    root.querySelectorAll('[data-llwa-anchor]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href') || '';
        var hash = '';
        try {
          if (href.charAt(0) === '#') hash = href;
          else {
            var u = new URL(href, window.location.href);
            if (u.pathname === window.location.pathname) hash = u.hash;
          }
        } catch (err) {}
        if (!hash) return;
        var target = resolveHub(hash, true);
        if (!target) return;
        e.preventDefault();
        scrollToEl(target);
        try { history.replaceState(null, '', '#ll-tcg-hub'); } catch (err2) {}
      });
    });

    /* ---- story fold (phones) ---- */
    var prose = root.querySelector('[data-prose]');
    var toggle = root.querySelector('[data-prose-toggle]');
    var mq = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
    var open = false;
    function applyFold() {
      if (!prose || !toggle) return;
      var phone = !!(mq && mq.matches);
      if (!phone) {
        prose.classList.remove('is-folded');
        toggle.hidden = true;
        return;
      }
      /* Only fold when there is enough to be worth folding. */
      prose.classList.remove('is-folded');
      var full = prose.scrollHeight;
      if (full < 220) { toggle.hidden = true; return; }
      toggle.hidden = false;
      prose.classList.toggle('is-folded', !open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    if (toggle) {
      toggle.addEventListener('click', function () {
        open = !open;
        prose.classList.toggle('is-folded', !open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        var t = toggle.querySelector('span');
        if (t) {
          if (!t.__orig) t.__orig = t.textContent;
          t.textContent = open ? 'Show less' : t.__orig;
        }
        if (!open && prose.getBoundingClientRect().top < 0) prose.scrollIntoView({ block: 'start' });
      });
    }
    applyFold();
    if (mq) {
      if (mq.addEventListener) mq.addEventListener('change', applyFold);
      else if (mq.addListener) mq.addListener(applyFold);
    }
  }

  function bootAll() {
    document.querySelectorAll('[data-llwa]').forEach(boot);
    /* A #ll-tcg-hub link from another page lands on the hub. Only real ids
       count here: a stray hash must not scroll a first-time visitor. */
    if (window.location.hash && !bootAll.__hashDone) {
      bootAll.__hashDone = true;
      var t = resolveHub(window.location.hash, false);
      if (t && t.hasAttribute('data-lltc-root')) setTimeout(function () { scrollToEl(t); }, 120);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll);
  else bootAll();
  document.addEventListener('shopify:section:load', bootAll);
})();
